import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-etc" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "etc-head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "etc-title" }, "로또 도구"),
  /*#__PURE__*/_createElementVNode("p", { class: "etc-sub" }, "당첨금 세금 계산과 자주 쓰는 공식 사이트 바로가기를 모았어요.")
], -1)
const _hoisted_4 = { class: "section-card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "당첨금 세금 계산기", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "당첨금을 넣으면 세금을 뗀 실수령액을 계산해 드려요.", -1)
const _hoisted_7 = { class: "tax-input-row" }
const _hoisted_8 = { class: "tax-quick-btns" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "tax-result"
}
const _hoisted_11 = { class: "tax-result-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "tax-label" }, "당첨금", -1)
const _hoisted_13 = { class: "tax-value" }
const _hoisted_14 = { class: "tax-result-row" }
const _hoisted_15 = { class: "tax-label" }
const _hoisted_16 = { class: "tax-value tax-deduct" }
const _hoisted_17 = { class: "tax-result-row total" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "tax-label" }, "실수령액", -1)
const _hoisted_19 = { class: "tax-value tax-net" }
const _hoisted_20 = {
  key: 0,
  class: "tax-net-ratio"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"tax-brackets\"><div class=\"tax-brackets-title\">세율 구간</div><ul><li><span>5만원 이하</span><b>비과세</b></li><li><span>5만원 초과 ~ 3억원</span><b>22%</b></li><li><span>3억원 초과분</span><b>33%</b></li></ul><p class=\"tax-brackets-note\">소득세 + 주민세(지방소득세) 포함. 5만원 초과분에 대해 과세됩니다.</p></div>", 1)
const _hoisted_22 = { class: "section-card" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "등수별 당첨 조건", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "몇 개를 맞히면 몇 등인지, 당첨금은 어떻게 정해지는지 정리했어요.", -1)
const _hoisted_25 = { class: "rank-info-list" }
const _hoisted_26 = { class: "rank-detail" }
const _hoisted_27 = { class: "rank-condition" }
const _hoisted_28 = { class: "rank-prize-info" }
const _hoisted_29 = { class: "section-card" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "공식 사이트 바로가기", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "동행복권 공식 페이지로 이동합니다. 새 탭에서 열려요.", -1)
const _hoisted_32 = { class: "links-list" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "link-text" }
const _hoisted_35 = { class: "link-title" }
const _hoisted_36 = { class: "link-desc" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "link-arrow",
  "aria-hidden": "true"
}, "↗", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prizeAmount) = $event)),
            class: "tax-input",
            placeholder: "당첨금 입력 (원)"
          }, null, 512), [
            [
              _vModelText,
              _ctx.prizeAmount,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("button", {
            class: "tax-calc-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.calculateTax && _ctx.calculateTax(...args)))
          }, "계산")
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickAmounts, (q) => {
            return (_openBlock(), _createElementBlock("button", {
              key: q.value,
              onClick: ($event: any) => {_ctx.prizeAmount = q.value; _ctx.calculateTax()}
            }, _toDisplayString(q.label), 9, _hoisted_9))
          }), 128))
        ]),
        (_ctx.taxResult !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatKRW(_ctx.taxResult.prize)), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, "세금 (" + _toDisplayString(_ctx.taxResult.taxRate) + ")", 1),
                _createElementVNode("span", _hoisted_16, "-" + _toDisplayString(_ctx.formatKRW(_ctx.taxResult.tax)), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatKRW(_ctx.taxResult.net)), 1)
              ]),
              (_ctx.taxResult.prize > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createTextVNode(" 당첨금의 "),
                    _createElementVNode("b", null, _toDisplayString(Math.round((_ctx.taxResult.net / _ctx.taxResult.prize) * 100)) + "%", 1),
                    _createTextVNode("를 받아요 ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_21
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankInfoList, (info) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "rank-info-item",
              key: info.rank
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rank-badge", 'rank-' + info.rank])
              }, _toDisplayString(info.rank) + "등", 3),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(info.condition), 1),
                _createElementVNode("div", _hoisted_28, _toDisplayString(info.prizeDesc), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.url,
              href: link.url,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "link-item"
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(link.title), 1),
                _createElementVNode("span", _hoisted_36, _toDisplayString(link.desc), 1)
              ]),
              _hoisted_37
            ], 8, _hoisted_33))
          }), 128))
        ])
      ])
    ])
  ]))
}